export const shouldExtractUnifiedDashboards = (): boolean => {
  return window?.location?.href?.indexOf?.('embed=true') > 0;
};
